import { styled } from '@mui/material'

export const UpcomingSessionsWrapper = styled('div')(() => ({
  display: 'grid',
  gap: '12px',
}))
